import { lazy } from "react";

// Lazy load all components
const Default = lazy(() => import("../Components/Dashboard/Default"));
const OnlineCourse = lazy(() => import("../Components/Dashboard/OnlineCourse"));
const Chart = lazy(() => import("../Components/Widgets/Chart"));
const General = lazy(() => import("../Components/Widgets/General"));
const CourseManagerContain = lazy(() => import("../Components/Application/Admin/CourseManager"));
const ChaptersTable = lazy(() => import("../Components/Application/Admin/CourseManager/tables/ChaptersTable"));
const UsersContainer = lazy(() => import("../Components/Application/Admin/Users"));
const SessionsContainer = lazy(() => import("../Components/Application/Admin/Sessions"));
const ProfileContainer = lazy(() => import("../Components/Application/Profile"));
const BrowseCoursesContainer = lazy(() => import("../Components/Application/Courses/BrowseCourses"));
const FavouritesContainer = lazy(() => import("../Components/Application/Courses/Favourites"));
const CoursePage = lazy(() => import("../Components/Application/Courses/CoursePage"));
const NewCoursesContainer = lazy(() => import("../Components/Application/Admin/BuildCourses"));
const ChapterContainer = lazy(() => import("../Components/Application/Courses/CoursePage/Chapter"));
const ContentContainer = lazy(() => import("../Components/Application/Admin/CourseManager/Content"));
const OffresContainer = lazy(() => import("../Components/Application/Offres"));
const AiChatbotContainer = lazy(() => import("../Components/Application/AI-Chat"));
const SamplePage = lazy(() => import("../Components/Pages/Sample"));

export const routes = [
  {
    path: `/dashboard`,
    Component: Default,
    roles: ["admin"]
  },
  {
    path: `/app/users`,
    Component: UsersContainer,
    roles: ["admin"],
  },
  {
    path: `/app/sessions`,
    Component: SessionsContainer,
    roles: ["admin"],
  },
  {
    path: `/app/new-courses`,
    Component: NewCoursesContainer,
    roles: ["admin"],
  },
  {
    path: `/app/course-manager`,
    Component: CourseManagerContain,
    roles: ["admin"],
  },
  {
    path: `/app/course-manager/:courseId/chapters`,
    Component: ChaptersTable,
    roles: ["admin"],
  },
  {
    path: `/app/course-manager/:courseId/chapters/:chapterId`,
    Component: ContentContainer,
    roles: ["admin"],
  },
  {
    path: `/widgets/general/:layout`,
    Component: General,
  },
  {
    path: `/widgets/chart`,
    Component: Chart,
  },
  {
    path: `/app/home`,
    Component: OnlineCourse,
    roles: ["user"],
  },
  {
    path: `/app/courses`,
    Component: BrowseCoursesContainer,
    roles: ["admin", "user"],
  },
  {
    path: `/app/favourites`,
    Component: FavouritesContainer,
    roles: ["admin", "user"],
  },
  {
    path: `/app/offres`,
    Component: OffresContainer,
    roles: ["admin", "user"],
  },
  {
    path: `/app/ai-chatbot`,
    Component: AiChatbotContainer,
    roles: ["user"],
  },
  {
    path: `/app/courses/:courseId`,
    Component: CoursePage,
    roles: ["admin", "user"],
  },
  {
    path: "/app/chapter/:chapterId",
    Component: ChapterContainer,
    roles: ["admin", "user"],
  },
  {
    path: `/app/wallet`,
    Component: SamplePage,
    roles: ["admin", "user"],
  },
  {
    path: `/app/achievements`,
    Component: SamplePage,
    roles: ["admin", "user"],
  },
  {
    path: `/app/my-profile`,
    Component: ProfileContainer,
    roles: ["admin", "user"],
  },
  {
    path: `/pages/sample-page`,
    Component: SamplePage,
  },
];